import React from 'react';
import PromoBadge from '../PromoBadge/PromoBadge';
import './Hero.css';

const Hero = ({ showPromo = false, promoSkin = 'fire' }) => {
  const scrollToCTA = (e) => {
    e.preventDefault();
    const section = document.querySelector('.cta-section');
    if (section) {
      const rect = section.getBoundingClientRect();
      const centered = rect.top + window.pageYOffset - (window.innerHeight - rect.height) / 2;
      window.scrollTo({ top: Math.max(0, centered), behavior: 'smooth' });
    }
  };

  const scrollToModules = (e) => {
    e.preventDefault();
    const modulesSection = document.querySelector('.module-2-section');
    if (modulesSection) {
      const navbarHeight = 80;
      const elementPosition = modulesSection.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - navbarHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="hero">
      <div className="hero-content">
        <div className="hero-text">
          <h1 className="hero-title">
            Pass Any Test<br />
            <span className="hero-accent">Undetected & Secure</span>
          </h1>
          <p className="hero-subtitle">
            Bypass any proctored assessment: exams, certifications, job interviews, or work evaluations.<br />
            Trusted by 1000+ professionals worldwide.
          </p>
          <div className="hero-buttons">
            <a href="#contact" onClick={scrollToCTA} className="primary-button">
              <span>Contact Us</span>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M4 10H16M16 10L11 5M16 10L11 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </a>
            <button className="secondary-button" onClick={scrollToModules}>View Solutions</button>
          </div>

          {showPromo && <PromoBadge variant="hero" skin={promoSkin} />}
        </div>

        <div className="hero-image-container">
          {/* Декоративные плавающие элементы */}
          <div className="floating-orb floating-orb-1"></div>
          <div className="floating-orb floating-orb-2"></div>
          
          <img 
            src="/images/hero-person.webp" 
            alt="Secure exam solutions" 
            className="hero-person-image"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
